import { format } from 'date-fns-tz';
import type { UpdateServiceOrderPayload } from 'contracts/service-orders';
import type { FormSchema } from './form-schema';

export const formatTzDate = (date: Date) => {
  return format(date, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS', {
    timeZone: 'America/Sao_Paulo',
  });
};

export const formatDate = (date: Date) => {
  return format(date, 'yyyy-MM-dd', {});
};

export const createUpdateServiceOrderPayload = (formData: FormSchema): UpdateServiceOrderPayload => {
  return {
    productsDeliveredAt: formData.productsDeliveredAt ? formatTzDate(formData.productsDeliveredAt) + '-03:00' : null,
    startDate: formData.startDate ? formatTzDate(formData.startDate) + '-03:00' : null,
    endDate: formData.endDate ? formatTzDate(formData.endDate) + '-03:00' : null,
    deadlineDate: formData.deadlineDate ? formatTzDate(formData.deadlineDate) + '-03:00' : null,
    workedHours: formData.workedHours ? +formData.workedHours : null,
    personQuantity: formData.personQuantity ? +formData.personQuantity : null,
  };
};